import {Component, Input, Type} from '@angular/core';
import {IGetClass, IModalWindow} from '../../../utils/interfaces/modal-dialog.interface';
import {ModalWindowsTypes} from '../../../core/enums';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'asg-extra-copy-dialog',
    templateUrl: './extra-copy-dialog.component.html',
    styleUrls: ['./extra-copy-dialog.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class ExtraCopyDialogComponent implements IModalWindow {
  @Input() ok: () => void;
  @Input() no: () => void;

  getWindowType(): Type<IModalWindow> {
    return ExtraCopyDialogComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.EXTRA_COPY_DIALOG;
  }

  getInstanceOf(type: string): IModalWindow | IGetClass | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'IGetClass':
        return this as unknown as IGetClass;
      default: return null;
    }
  }

  getClass(): string {
    return 'extra-copy-dlg';
  }

}
